import React from "react";
import { motion } from "framer-motion";
import "./HeroSection.css";
import HeroImage from "../assets/image/imageHero.avif"

function HeroSection() {
  return (
    <motion.div
      className="hero"
      id="servicios"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      <motion.div
        className="hero-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 1 }}
      >
        <motion.div
          className="text-hero"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          <h1 className="t-title-1">La solución confiable <br></br> para traslados corporativos</h1>
          <p className="t-subtitle">Conecta tu empresa con conductores <br></br> confiables mediante tecnología avanzada. <br></br><br></br> Pruébalo gratis.</p>
        </motion.div>
        <motion.div
          className="cta-buttons"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
        >
          <a href="https://service.conexs.app" target="_blank" className="btn btn-primary t-subtitle">
            Reservar Ahora
          </a>
          <a href="https://business.conexs.app" target="_blank" className="btn btn-secondary t-subtitle">
            Regístrate como Empresa
          </a>
        </motion.div>
      </motion.div>
      <motion.div style={{ borderRadius:'16px' }}>
        <img src={HeroImage} className="hero-image" alt="hero-image"></img>
      </motion.div>
    </motion.div>
  );
}

export default HeroSection;
